export enum TooltipMode {
  EMOJIS = 'EMOJIS',
  VARIABLES = 'VARIABLES',
}

export enum EntityType {
  EMOJI = 'EMOJI',
  VARIABLE = 'VARIABLE',
}
